import React from "react";
import ApprovalStatus from "./Components/approvalStatus";
import ViewReceipt from "./ViewReceipt";
import { useState } from "react";
import { StampToDate, formatedPrice } from "../../Utils/utils";
import { FiTrash2 } from "react-icons/fi";
import { Checkbox } from "Components/Library";

function Receipt({ selectable, openId, onDrag, onSelect, selected, id = "", date, createdAt, amount = 0, merchant, currency = "INR", categoryId, category = {}, status = "", description = "", attachments = [], approvers = [], onReload = () => {}, onDelete }) {
	const [OpenId, setOpenId] = useState(openId);
	const editable = status === "needsApproval" || status === "inPolicy" || status === "draft" || status === "outOfPolicy";

	const draggable = onDrag && editable && status !== "pending" && status !== "draft";

	return (
		<>
			<div
				draggable={draggable}
				onDragEnd={() => onDrag()}
				onDragStart={() => onDrag({ id, date, createdAt, amount, merchant, currency, categoryId, category, status, description, attachments, approvers })}
				onClick={() => {
					if (selectable) {
						onSelect({ id, date, createdAt, amount, merchant, currency, categoryId, category, status, description, attachments, approvers });
					} else {
						setOpenId(id);
					}
				}}
				className={`flex overflow-hidden relative flex-col justify-between min-w-min rounded-xl border shadow-sm cursor-pointer bg-canvas hover:bg-light group ${selectable ? "cursor-pointer" : "cursor-default"}`}
			>
				<div className="p-4">
					<div className="flex justify-between">
						<div className="flex gap-2 items-center">
							<div onClick={(e) => e.stopPropagation()}>{selectable && <Checkbox checked={selected} onChange={() => onSelect({ id, date, createdAt, amount, merchant, currency, categoryId, category, status, description, attachments, approvers })} />}</div>
							<h2>
								{currency} {formatedPrice(amount)}
							</h2>
						</div>
						<div className="text-label">{StampToDate(createdAt)}</div>
					</div>
					<div className="mt-2 text-xs text-secondary">
						Spent on {StampToDate(date)} at {merchant} for {category?.name}
					</div>
				</div>
				<ApprovalStatus draggable={draggable} status={status} id={id} />
				{onDelete && (
					<div
						onClick={(e) => {
							e.stopPropagation();
							onDelete(id);
						}}
						className="h-[0] group-hover:h-[2.5rem] transition-all flex-center absolute bottom-0 left-0 right-0 bg-dangerText text-white gap-2 text-xs"
					>
						<FiTrash2 /> Remove
					</div>
				)}
			</div>
			<ViewReceipt onReload={onReload} receiptId={OpenId} onClose={() => setOpenId()} />
		</>
	);
}

export default Receipt;
